module.exports = __webpack_public_path__ + "static/media/Vince Pietrantonio.e9ae8f77.png";